/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Web_Title_AccentInputs */

const tr_landing_web_title_accent = /** @type {(inputs: Landing_Web_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kendi mağazanız da olsun.`)
};

const en_landing_web_title_accent = /** @type {(inputs: Landing_Web_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Run your own store as well.`)
};

const de_landing_web_title_accent = /** @type {(inputs: Landing_Web_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Holen Sie sich Ihren eigenen Shop.`)
};

const ru_landing_web_title_accent = /** @type {(inputs: Landing_Web_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заведите собственный магазин.`)
};

/**
* | output |
* | --- |
* | "Run your own store as well." |
*
* @param {Landing_Web_Title_AccentInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_web_title_accent = /** @type {((inputs?: Landing_Web_Title_AccentInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Web_Title_AccentInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_web_title_accent(inputs)
	if (locale === "de") return de_landing_web_title_accent(inputs)
	if (locale === "ru") return ru_landing_web_title_accent(inputs)
	return tr_landing_web_title_accent(inputs)
});